import React, { useContext } from "react";
import { AppContext } from "../context/Context";

export default function VisionMission() {
  const { visionMission, loading } = useContext(AppContext);

  if (loading) return null;
  if (!visionMission) return null;

  const { vision, mission } = visionMission;

  return (
    <>
      {/* HEADER */}
      <section className="section-wrap text-center mb-5">
        <div className="eyebrow mb-3">
          <span className="star">
            <i className="fa-solid fa-rocket"></i>
          </span>
          OUR PURPOSE
        </div>

        <h1 className="title">Vision & Mission</h1>
      </section>

      {/* CARDS */}
      <section className="container-fluid mt-1">
        <div className="row g-4">

        {/* VISION */}
<div className="col-lg-6 d-flex">
  <div className="vm-card violet w-100">

    <div className="vm-heading">
      <div className="icon-wrap violet">
        <i className="fa-regular fa-eye"></i>
      </div>

      <h3 className="card-title mb-0">{vision.title}</h3>
    </div>

    <div className="vm-card-inner">
      <p className="card-desc">{vision.description}</p>

      <ul className="vm-list">
        {vision.points.map((item, index) => (
          <li key={index}>
            <span className="tick">
              <i className="fa-solid fa-check"></i>
            </span>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>

  </div>
</div>

          {/* MISSION */}
<div className="col-lg-6 d-flex">
  <div className="vm-card mint w-100">

    <div className="vm-heading">
      <div className="icon-wrap mint">
        <i className="fa-solid fa-bullseye"></i>
      </div>

      <h3 className="card-title mb-0">{mission.title}</h3>
    </div>

    <div className="vm-card-inner">
      <p className="card-desc">{mission.description}</p>

      <ul className="vm-list">
        {mission.points.map((item, index) => (
          <li key={index}>
            <span className="tick">
              <i className="fa-solid fa-check"></i>
            </span>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>

  </div>
</div>

        </div>
      </section>
    </>
  );
}
